import { observer } from "mobx-react";
import React from "react";
import { NavButton } from "../../components/settings/navButton";
import { useStore } from "../../models";
import { ReportsScope } from "../../models/reports/ReportsScope";
import { IReportTabsGroup } from "../../models/reports/reportsStore";
import { Path } from "../../models/router";
import { DashboardView } from "../dashboard/views/DashboardView";
import styles from "../settings/settingsNavigation.css";

interface Props {
  view: DashboardView;
  scope: ReportsScope;
}

export const ReportsNavigation = observer(function ReportsNavigationComponent({
  view,
  scope
}: Props) {
  const { reportsStore, uiStore, currentUserStore } = useStore();

  const renderReportsTab = (tabsGroup: IReportTabsGroup | undefined) => {
    return (
      tabsGroup && (
        <div className={styles["nav-section"]}>
          <div className={styles["nav-section-title"]}>{tabsGroup.label}</div>
          {tabsGroup.reportsTabs.map((tab) => (
            <NavButton
              key={tab.scope + tab.tabId}
              isActive={scope === tabsGroup.reportsScope && view === tab.dashboardView}
              linkTo={Path.reports(tab.dashboardView, tabsGroup.reportsScope)}
            >
              {tab.label}
            </NavButton>
          ))}
        </div>
      )
    );
  };

  return (
    <>
      <div className={styles["navigation-container"]}>
        {
          uiStore.canDisplayReports(ReportsScope.Yours) &&
          renderReportsTab(reportsStore.yoursTabsGroup)
        }
        {
          uiStore.canDisplayReports(ReportsScope.Groups) &&
          currentUserStore.profile!.groups.length > 0 &&
          renderReportsTab(reportsStore.groupTabsGroup)
        }
        {
          uiStore.canDisplayReports(ReportsScope.Conversations) &&
          renderReportsTab(reportsStore.conversationsTabsGroup)
        }
        {
          uiStore.canDisplayReports(ReportsScope.Advisers) &&
          renderReportsTab(reportsStore.advisersTabsGroup)
        }
        {
          uiStore.canDisplayReports(ReportsScope.Org) &&
          renderReportsTab(reportsStore.orgTabsGroup)
        }
      </div>
    </>
  );
});
